const getFileName = (fileMime) => {
    return `${fileMime.split('/')?.[0]?.toLocaleLowerCase()}.${fileMime
        .split('/')?.[1]
        ?.toLocaleLowerCase()}`;
};
export default getFileName;
